<h2 mat-dialog-title>{{ 'ml_151250' | translate }}</h2>
<!-- <mat-dialog-content>
  {{ 'ml_151250' | translate }}
</mat-dialog-content> -->
<mat-dialog-actions>
  <button mat-raised-button style="background-color: whitesmoke; color: black;" mat-dialog-close>{{ 'ml_143932' | translate }}</button>
  <span class="example-spacer"></span>
  <button mat-raised-button style="background-color: #00BFFF; color: white;" cdkFocusInitial (click)="markRead()">{{ 'ml_143931' | translate }}</button>
</mat-dialog-actions>